var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"height":"24","width":"24","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1zm-.94 6.108C9.728 6.276 8 7.233 8 8.804v6.392c0 1.57 1.728 2.528 3.06 1.696l5.113-3.196a2 2 0 0 0 0-3.392z","fill-rule":"evenodd"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }